import React from 'react';

import { useStore } from 'stores';

import CopyToClipboard from './CopyToClipboard';

interface Props
{
  text?: string,
}
export const DefaultCopyToClipboard: React.FC<Props> = ({text}) =>
{
  const { uiStore } = useStore();
  return <CopyToClipboard text={text} tip={uiStore.labels.common.clipboard.tip} successText={uiStore.labels.common.clipboard.copied} />;
}